import { Box, useTheme } from "@mui/material";
import AddBusinessesList from "app/components/BusinessList/AddBusinessesList";
import CreateListForm from "app/components/BusinessList/CreateListForm";
import CreateListHeader from "app/components/BusinessList/CreateListHeader";
import { useLazyGetBusinessListByRegionIdQuery } from "lib/features/business/businessService";
import { Business } from "lib/features/business/types";
import { useGetBusinessListByIdQuery } from "lib/features/businessList/businessListService";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import authServices from "services/auth-service";

const CreateBusinessList = () => {
  const theme = useTheme();
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [showBusinesses, setShowBusinesses] = useState<boolean>(false);
  const [selectedBusinesses, setSelectedBusinesses] = useState<Business[]>([]);
  const [userData, setUserData] = useState<any>({});
  const [businessList, setBusinessList] = useState<Business[]>([]);
  const [filteredBusiness, setFilteredBusiness] = useState<Business[]>([]);

  const queryParams = new URLSearchParams(location.search);
  const listId = Number(queryParams.get("list"));

  const { data: businessListData, isLoading } = useGetBusinessListByIdQuery(
    { id: Number(listId) },
    { skip: !listId }
  );

  const [getBusinessListByRegionId] = useLazyGetBusinessListByRegionIdQuery();

  const handleBusinessRecords = (business: Business, action: boolean) => {
    if (action) {
      // adding in selected business
      setSelectedBusinesses([...selectedBusinesses, business]);
    } else {
      // removing from selected business
      setSelectedBusinesses(
        selectedBusinesses.filter((item) => item?.id !== business?.id)
      );
    }
  };

  useEffect(() => {
    setSelectedBusinesses(
      businessListData?.businesses && businessListData?.businesses?.length > 0
        ? businessListData?.businesses
        : []
    );
  }, [businessListData]);

  useEffect(() => {
    const fetchUser = async () => {
      if (Number(id)) {
        try {
          const response = await authServices.fetchUser(Number(id));
          setUserData(response?.data);
        } catch (error: any) {
          console.error("Error fetching chats:", error?.message);
        } finally {
        }
      }
    };

    fetchUser();
  }, []);

  useEffect(() => {
    const fetchBusinesses = async () => {
      if (
        id &&
        userData?.regions?.length > 0 &&
        userData?.regions[0]?.region?.id
      ) {
        const response = await getBusinessListByRegionId({
          region_id: userData?.regions[0]?.region.id,
          userid: Number(id),
        });
        if (response?.data) {
          setBusinessList(response?.data);
          setFilteredBusiness(response?.data);
        }
      }
    };

    fetchBusinesses();
  }, [userData, id, getBusinessListByRegionId]);

  useEffect(() => {
    // only list owner can edit the list
    if (businessListData?.user?.id !== Number(id) && listId) {
      return navigate(-1);
    }
  }, []);

  if (isLoading) {
    return <></>;
  }

  return (
    <>
      {showBusinesses ? (
        <Box margin="1rem">
          <AddBusinessesList
            handleBusinessRecords={handleBusinessRecords}
            selectedBusinesses={selectedBusinesses}
            setShowBusinesses={setShowBusinesses}
            businessList={businessList}
            filteredBusiness={filteredBusiness}
            setFilteredBusiness={setFilteredBusiness}
          />
        </Box>
      ) : (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          width="100%"
          marginY="1rem"
        >
          <Box
            sx={{
              maxWidth: {
                xs: "90vw", // small
                sm: "70vw", // tab
                md: "40vw", // large
              },
            }}
            width="100%"
            fontFamily={theme.typography.fontFamily}
          >
            {/* Create Form Header */}
            <CreateListHeader />

            {/* Form */}
            <CreateListForm
              userId={Number(id)}
              setShowBusinesses={setShowBusinesses}
              selectedBusinesses={selectedBusinesses}
              handleBusinessRecords={handleBusinessRecords}
              businessListData={businessListData}
              isEdit={!!listId}
            />
          </Box>
        </Box>
      )}
    </>
  );
};

export default CreateBusinessList;
